
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from 'react-hook-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Badge, Breadcrumb, Button, Card, Form, Table } from '@themesberg/react-bootstrap';
import { confirmDeleteToast, sendError, sendSuccess } from "../helpers/Helper";
import { Model } from "../components/Model";
import { Textbox } from "../components/Textbox";
import { SelectBox } from "../components/SelectBox";
import { API_URL_ENDPOINT } from "../appsetting";
import TextEditor from "../components/TextEditor";
import CustomPagination from "../components/CustomPagination";
import { useNavigate} from "react-router-dom";
import { Routess } from "../Routes/routes";
import { Avatar } from "@mui/material";
import { useApi } from "../helpers/useApi";

export const Support = () => {
  const callApi = useApi();
  const [openModel, setOpenModel] = useState(false);
  const navigate = useNavigate();
  const methods = useForm();
  const { register,handleSubmit, reset, formState: { errors, isSubmitting }, watch , setValue } = methods;
  const selectedType = watch("type");
  const [searchTerm, setSearchTerm] = useState("");

  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [pagination, setPagination] = useState(
    {currentPage:1,
      pageSize:10,
      totalPages:1,
      totalRecords:0
    })

  useEffect(()=>{
    getGroupData();
    getData();
  },[])

  const handlePageChange = (newPage) =>{    
    setPagination((prev) => ({...prev, currentPage: newPage}))
    getData(newPage);
  }

  const getData = async (cp = null) => {
    try{
      setDataLoading(true);
      const response = await callApi(API_URL_ENDPOINT.User+`?page=${cp ?? pagination.currentPage}&pageSize=${pagination.pageSize}`);
      if(response.status){
        setData(response.data?.data);
        setPagination(response.data?.pagination);
      }
    }catch{
      setData([]);
    }finally{
      setDataLoading(false);
    }
  }

  const getGroupData = async (cp = null) => {
    try{
      setDataLoading(true);
      const response = await callApi(API_URL_ENDPOINT.UserGroup);
      if(response.status){
        setGroupData(response.data);
      }
    }catch{
      setData([]);
    }finally{
      setDataLoading(false);
    }
  }

  const handleView = (id) => {
    navigate(Routess.NewsAndEvent.path + `/${id}`)
  }

  const onSubmit = async (data) => {
    try{
      const payload = {
        "FirstName": data.firstName,
        "lastName": data.lastName || null,
        "fullName": "",
        "email": data.email,
        "password": data.password,
        "userGroupID": data.usergroupid,
      }
      const response = await callApi(API_URL_ENDPOINT.User, {
          method: 'POST',
          data: payload,
      });
      if(response.status){
          reset();
          setOpenModel(false);
          getData();
          sendSuccess(response.message);
      }else{
          throw Error(response.message || "Something Went Wrong")
      }
    }catch(ex){
        sendError(ex.message)
    }

  };

  const handleDelete = () => {
    confirmDeleteToast(() => {
      sendSuccess("Deleted successfully!");
    });
  };

  return (
    <>
      <Model show={openModel} size={'md'}>
        <h5>Add User</h5>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Textbox Label="First Name" name={'firstName'} Placeholder="Enter First Name" validationRules={{required: "First Name is required"}} register={register} errors={errors} watch={watch}/>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Textbox Label="Last Name" name={'lastname'} Placeholder="Enter Last Name" register={register} errors={errors} watch={watch}/>
                </Form.Group>
              </div>
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <Textbox Label="Email" name={'email'} Placeholder="Enter E-mail" validationRules={{required: "Email is required"}} register={register} errors={errors} watch={watch}/>
                </Form.Group>
              </div>
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <SelectBox Label="User Group" name={'usergroupid'} validationRules={{required: "User Group is required"}} register={register} errors={errors} watch={watch}>
                    <option value="">Select User Group</option>
                    {groupData?.map((item, index)=>(
                       <option value={item.id}>{item.name}</option>
                    ))}
                  </SelectBox>
                </Form.Group>
              </div>
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <Textbox Label="Password" Type="text" name={'password'} Placeholder="Enter Password" validationRules={{required: "Password is required"}} register={register} errors={errors} watch={watch}/>
                </Form.Group>
              </div>
            </div>
            <div className="text-end">
              <Button type="Button" className="me-2" variant="outline-danger" onClick={()=>setOpenModel(false)}>Close</Button>
              <Button type="submit" disabled={isSubmitting} variant="success">Save Changes</Button>
            </div>
          </Form>
          </FormProvider>
      </Model>



      <div className="justify-content-between d-flex flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            {/* <Breadcrumb.Item>NPSP</Breadcrumb.Item> */}
            <Breadcrumb.Item active>Support</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Support</h4>
            {/* <p className="mb-0">
              Dozens of reusable components built to provide buttons, alerts, popovers, and more.
            </p> */}
            {/* <Button variant="primary" className="m-1" onClick={()=>{setOpenModel(true); reset();}}>Add New User</Button> */}
          </div>
        </div>
        <div className="w-25">
              <Form.Control value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} onKeyDown={(e) => {if (e.key === "Enter") getData(1);}} type="text" className="shadow-none" placeholder={"Search..."} />
            </div>
      </div>

      {/* <PageTrafficTable /> */}
      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="pb-0">
          {dataLoading ? (
            <div className="text-center my-3">
              <span className="spinner-border text-primary" role="status"></span>
              {/* <p>Loading News & Events...</p> */}
            </div>
          ) : (
            <Table responsive className="table-centered table-nowrap rounded mb-0">
              <thead className="thead-light">
                <tr>
                  <th className="border-0 text-center">#</th>
                  <th className="border-0 text-center">Create Date</th>
                  <th className="border-0">From</th>
                  <th className="border-0">To</th>
                  <th className="border-0 text-center">Shipper</th>
                  <th className="border-0 text-center">Product</th>
                  <th className="border-0 text-center">Status</th>
                  <th className="border-0 text-end pe-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center align-middle">
                        {(pagination.currentPage - 1) * pagination.pageSize + index + 1}
                      </td>
                      <td className="fw-bold align-middle text-center">{item.fullName}</td>
                      <td className="fw-bold align-middle">{item.fullName}</td>
                      <td className="fw-bold align-middle">{item.email}</td>
                      <td className="fw-bold align-middle text-center">{item.userGroup?.name}</td>
                      <td className="fw-bold align-middle text-center">{item.userGroup?.name}</td>
                      <td className="align-middle text-center">{item.isActive ? 'Active' : 'InActive' }</td>
                      <td className="text-end align-middle">
                        <Button variant="primary" className="btn-sm" onClick={()=>handleView(item.id)}>View Details</Button>
                        {/* <Button onClick={handleDelete} variant="danger" className="btn-sm">Remove</Button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        <div className="d-flex justify-content-end">
          <CustomPagination totalPages={pagination.totalPages} loading={dataLoading} onPageChange={handlePageChange}/>
        </div>
        </Card.Body>
      </Card>
    </>
  );
};
